import React, { useContext } from "react";

import SEO from "../components/SEO";
import { LanguageContext } from "../LanguageContext"; // Import the LanguageContext

const Aboutus = () => {
  const { language } = useContext(LanguageContext); // Get the current language
// ✅ **SEO Metadata for About Us Page**
const metaTitle = "About Us - Snapseed QR Codes | Discover Our Story";
const metaDescription = "Welcome to Snapseedqrcodes.download - your go-to source for Snapseed QR codes and photo editing tools. Learn more about our journey and mission.";
const metaUrl = "https://www.snapseedqrcodes.download/about";
const metaImage = "https://www.snapseedqrcodes.download/snapseedqrcodes_logo.webp";

// ✅ **Schema Markup for Google SEO**
const schemaMarkup = {
  "@context": "https://schema.org",
  "@type": "AboutPage",
  "headline": metaTitle,
  "description": metaDescription,
  "url": metaUrl,
  "image": metaImage,
  "publisher": {
    "@type": "Organization",
    "name": "Snapseed QR Codes",
    "logo": metaImage
  }
};
  return (
    <div>
 {/* Use the SEO Component */}
 <SEO
        title={metaTitle}
        description={metaDescription}
        url={metaUrl}
        image={metaImage}
        schemaMarkup={schemaMarkup}
      />
      <section className="snapseed">
        <h2>{language === "english" ? "About Us" : "हमारे बारे में"}</h2>
        <p className="section-description">
          {language === "english"
            ? "Welcome to Snapseedqrcodes.download - where the photo magic begins!"
            : "स्वागत है Snapseedqrcodes.download पर - जहां फोटो जादू शुरू होता है!"}
        </p>

        <h3>{language === "english" ? "Our Story" : "हमारी कहानी"}</h3>
        <p className="section-description">
          {language === "english"
            ? "We started with a simple dream - to make photo editing fun and easy for everyone. Our passion for photography inspired us to create a place where you can find amazing Snapseed filters through QR codes."
            : "हमने एक साधारण सपने के साथ शुरुआत की - हर किसी के लिए फोटो संपादन को मजेदार और आसान बनाना। हमारे फोटोग्राफी के प्रति जुनून ने हमें ऐसी जगह बनाने की प्रेरणा दी जहां आप QR कोड के माध्यम से अद्भुत Snapseed फिल्टर पा सकें।"}
        </p>

        <h3>{language === "english" ? "What We Do" : "हम क्या करते हैं"}</h3>
        <p className="section-description">
          {language === "english"
            ? "Consider us your friendly photo editing companion. We help you transform your ordinary pictures into extraordinary memories using Snapseed QR codes. Whether you're taking your first photo or have been editing for years, we're here to make your journey colorful and exciting."
            : "हमें अपना मित्रवत फोटो संपादन साथी समझें। हम आपकी साधारण तस्वीरों को Snapseed QR कोड का उपयोग करके असाधारण यादों में बदलने में मदद करते हैं। चाहे आप अपनी पहली फोटो खींच रहे हों या वर्षों से संपादन कर रहे हों, हम आपकी यात्रा को रंगीन और रोमांचक बनाने के लिए यहां हैं।"}
        </p>

        <h3>{language === "english" ? "Our Services" : "हमारी सेवाएँ"}</h3>
        <p className="section-description">
          {language === "english"
            ? "We offer three main things to help you create beautiful photos:"
            : "हम आपको सुंदर फोटो बनाने में मदद करने के लिए तीन मुख्य चीजें प्रदान करते हैं:"}
        </p>
        <ul className="benefits-list">
          <li>
            {language === "english"
              ? "Step-by-Step Learning: We break down complex editing steps into simple, easy-to-follow guides. Our tutorials help you understand everything about using Snapseed QR codes. We explain things in a way that makes sense, even if you're just starting out."
              : "कदम-दर-कदम सीखना: हम जटिल संपादन चरणों को सरल, आसानी से अनुसरण करने योग्य मार्गदर्शिकाओं में तोड़ते हैं। हमारे ट्यूटोरियल आपको Snapseed QR कोड का उपयोग करने के बारे में सब कुछ समझने में मदद करते हैं।"}
          </li>
          <li>
            {language === "english"
              ? "Your Photo Library: Our website is where we share top downloadable Snapseed QR codes. You can share, download, or instantly scan these codes and use them to make your photos look amazing. We carefully select each code to ensure you get the best editing experience."
              : "आपकी फोटो लाइब्रेरी: हमारी वेबसाइट वह जगह है जहाँ हम शीर्ष डाउनलोड योग्य Snapseed QR कोड साझा करते हैं। आप इन कोडों को साझा कर सकते हैं, डाउनलोड कर सकते हैं या तुरंत स्कैन कर सकते हैं और उनका उपयोग करके अपनी तस्वीरों को अद्भुत दिखा सकते हैं।"}
          </li>
          <li>
            {language === "english"
              ? "Tips: Our blog is filled with useful advice and fun ideas. We share simple tips that you can start using today to make your photos look better. These are not just ideas—they are tested and proven methods."
              : "युक्तियाँ: हमारा ब्लॉग उपयोगी सलाह और मजेदार विचारों से भरा है। हम सरल युक्तियाँ साझा करते हैं जिनका उपयोग आप आज से ही कर सकते हैं ताकि आपकी फोटो बेहतर दिखें।"}
          </li>
        </ul>

        <h3>
          {language === "english"
            ? "Join Our Family"
            : "हमारे परिवार में शामिल हों"}
        </h3>
        <p className="section-description searchable-content">
          {language === "english"
            ? "We believe that great things happen when we help each other create beautiful photos. That's why we've created more than just a website—we've created a friendly place for everyone who loves photography. Every QR code we share and every tip we write helps you take better photos."
            : "हम मानते हैं कि जब हम एक दूसरे की सुंदर फोटो बनाने में मदद करते हैं, तब महान चीजें होती हैं। इसलिए हमने सिर्फ एक वेबसाइट नहीं बनाई है - हमने फोटोग्राफी से प्यार करने वाले हर किसी के लिए एक मित्रवत स्थान बनाया है।"}
        </p>

        <h3>{language === "english" ? "Get in Touch" : "संपर्क में रहें"}</h3>
        <p className="section-description searchable-content">
          {language === "english"
            ? "We love hearing from you! Whether you have questions, ideas, or just want to say hello, drop us a line at: snapseedqrcodes.download@gmail.com. Your thoughts help us make Snapseedqrcodes.download better every day. Together, let's make photo editing a shareable adventure! Remember: Photos capture moments, but editing brings them to life. Join us and let every picture tell its best story."
            : "हमें आपसे सुनकर खुशी होती है! चाहे आपके पास प्रश्न हों, विचार हों, या बस हैलो कहना हो, हमें एक पंक्ति ड्रॉप करें: snapseedqrcodes.download@gmail.com आपके विचार हमें Snapseedqrcodes.download को हर दिन बेहतर बनाने में मदद करते हैं। साथ में, आइए फोटो संपादन को एक साझा करने योग्य साहसिक कार्य बनाएं! याद रखें: फोटो पलों को कैप्चर करते हैं, लेकिन संपादन उन्हें जीवंत बनाता है। हमारे साथ जुड़ें और हर चित्र को उसकी सर्वश्रेष्ठ कहानी बताने दें।"}
        </p>
      </section>
    </div>
  );
};

export default Aboutus;
